import logger from '@/modules/Logger';

export default {
  async setVideoEffect(effect, virtualBgModel) {
    // Ensure VB init has completed before checking readiness
    if (this.vbInitPromise) {
      await this.vbInitPromise;
    }

    // Extension path: use VB processor if available
    if (this.vbProcessorReady) {
      try {
        this.videoEffect = effect;

        if (effect === 'blur') {
          // Only enable the processor if the camera is currently active.
          // If the camera is off, toggleCamera enables it when the camera
          // comes back on (it also pipes lazily via ensureVbPipelined).
          //
          // When the user joined without blur, the processor was never piped
          // (vbPipelined === false). Pipe it lazily here so enabling blur
          // actually affects the published track instead of silently no-oping.
          if (this.enableVideo && this.ensureVbPipelined()) {
            this.vbProcessor.setOptions({ type: 'blur', blurDegree: 2 });
            await this.vbProcessor.enable();
          }
        } else {
          if (this.vbPipelined) {
            await this.vbProcessor.disable();
          }
        }

        return await this.getMediaStream();
      } catch (error) {
        logger.error('[Agora] Error setting video effect', {
          operation: 'vbackground:set-effect',
          reason: error.message,
          event_type: 79
        });
        return { error };
      }
    }

    // Fallback path: use BodyPix canvas pipeline
    if (virtualBgModel) {
      this.virtualBackground = virtualBgModel;
    }

    if (this.virtualBackground) {
      this.videoEffect = effect;

      try {
        await this.virtualBackground
          .setEffect(effect)
          .setProvider('agora')
          .performSegmentation(this.videoDevice);

        let stream = await this.publishStreamToChannel();
        return { stream };
      } catch (error) {
        logger.error('[Agora] Error setting video effect (fallback)', {
          operation: 'vbackground:set-effect',
          reason: error.message,
          event_type: 79
        });
        return { error };
      }
    }

    // Neither path available
    logger.error('[Agora] VB not available (extension failed, no fallback model)', {
      operation: 'vbackground:set-effect'
    });
    return { error: 'VB not available' };
  }
};
